import React from "react";
import { Crown, Clock, UserCircleGear } from "@phosphor-icons/react";
import { useLang } from "../context/LanguageContext";
import { Reveal } from "./Reveal";

const icons = [Crown, Clock, UserCircleGear];

export const Services = () => {
  const { t } = useLang();
  const items = t.services.items;

  return (
    <section id="services" className="cfg relative py-16 md:py-24 bg-[#F7F7F5]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-12">
          <div>
            <Reveal>
              <p className="cfg-body text-[12px] font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-3">{t.services.overline}</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="cfg-display text-3xl md:text-5xl text-[#071B2F] tracking-tight max-w-2xl">{t.services.title}</h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="cfg-body text-[#071B2F]/55 max-w-xs md:text-right">{t.services.sub}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
          <Reveal className="md:col-span-7" y={50}>
            <div className="group relative h-[360px] overflow-hidden rounded-[24px] border border-[#071B2F]/8 shadow-[0_25px_60px_-35px_rgba(7,27,47,0.4)]" data-testid="service-card-0">
              <img src="https://images.pexels.com/photos/18369298/pexels-photo-18369298.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Intérieur Mercedes S-Class" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#071B2F] via-[#071B2F]/40 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-8">
                <Crown weight="light" size={36} className="text-[#D4AF37] mb-3" />
                <h3 className="cfg-display text-3xl text-white mb-2">{items[0].title}</h3>
                <p className="cfg-body text-white/75 max-w-md text-sm">{items[0].desc}</p>
              </div>
            </div>
          </Reveal>

          <div className="md:col-span-5 flex flex-col gap-4">
            {[1, 2].map((idx) => {
              const Icon = icons[idx];
              return (
                <Reveal key={idx} delay={idx * 0.1} y={50} className="flex-1">
                  <div className="group h-full min-h-[170px] rounded-[24px] border border-[#071B2F]/10 bg-white p-7 hover:border-[#D4AF37]/50 shadow-[0_20px_50px_-35px_rgba(7,27,47,0.35)] transition-colors flex flex-col justify-between" data-testid={`service-card-${idx}`}>
                    <Icon weight="light" size={32} className="text-[#D4AF37] group-hover:scale-110 transition-transform" />
                    <div className="mt-5">
                      <h3 className="cfg-display text-2xl text-[#071B2F] mb-1.5">{items[idx].title}</h3>
                      <p className="cfg-body text-[#071B2F]/55 text-sm">{items[idx].desc}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
